// Third-party Imports
import { configureStore } from '@reduxjs/toolkit'

// Slice Imports
import chatReducer from '@/redux-store/slices/chat'
import calendarReducer from '@/redux-store/slices/calendar'
import kanbanReducer from '@/redux-store/slices/kanban'
import emailReducer from '@/redux-store/slices/email'
import crmKanbanReducer from '@/redux-store/slices/crm-kanban'
import tasksKanbanReducer from '@/redux-store/slices/tasks-kanban'
import bookingCalendarReducer from '@/redux-store/slices/booking-calendar'
import meetingCalendarReducer from '@/redux-store/slices/meeting-calendar'
import projectsKanbanReducer from '@/redux-store/slices/projects-kanban'
import personalCalendarReducer from '@/redux-store/slices/personal-calendar'
import notificationsReducer from '@/redux-store/slices/notifications'
import roadmapReducer from '@/redux-store/slices/roadmap'
import mindmapReducer from '@/redux-store/slices/mindmap'

export const store = configureStore({
  reducer: {
    chatReducer,
    calendarReducer,
    kanbanReducer,
    emailReducer,
    crmKanbanReducer,
    tasksKanbanReducer,
    bookingCalendarReducer,
    meetingCalendarReducer,
    projectsKanbanReducer,
    personalCalendarReducer,
    notificationsReducer,
    roadmapReducer,
    mindmapReducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false })
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
